import React, { FC, useEffect, useRef, useState } from 'react';

import { Loader } from 'elements/loader';
import { useSelector } from 'react-redux';
import { isCountryBlacklistedSelector } from 'store/entities/config/selectors';

import './ConnectWalletDropdown.scss';

type OptionT = {
  label: string;
  value: string;
  image?: string;
};

type PropsT = {
  options: OptionT[];
  handlerSelect: Function;
  isLoading: boolean;
};

const ConnectWalletDropdown: FC<PropsT> = ({ options = [], handlerSelect = () => {}, isLoading }) => {
  const [isOpen, setIsOpen] = useState(false);
  const boxRef = useRef<HTMLDivElement>(null);
  const isForbiddenCountry = useSelector(isCountryBlacklistedSelector);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={boxRef} className="select connect-wallet-dropdown">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className={`connect-wallet-btn ${isForbiddenCountry ? 'disabled' : ''}`}
        disabled={isForbiddenCountry}>
        {isLoading && <Loader />}
        {_t('Connect Wallet', 'HEADER.CONNECT_WALLET')}
      </button>

      <div className={`select-instruments-list ${isOpen ? 'open' : 'close'}`} onClick={() => setIsOpen(!isOpen)}>
        {options.length 
          && !isForbiddenCountry 
          && options.map((option, index) => (
            <div
              key={option.value + index.toString()}
              className="select-instruments-list-names"
              onClick={() => handlerSelect(option.label)}
            >
              {option?.image && <img src={option?.image} alt={option.label} />}
              {option.label}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ConnectWalletDropdown;
